import React, { createContext, useContext, useState, ReactNode } from 'react'

interface ChatPopupState {
  isOpen: boolean
  isMinimized: boolean
  conversationId: string | null
  otherUserId: string | null
  otherUserName: string | null
}

interface ChatPopupContextType {
  state: ChatPopupState
  openChat: (userId: string, userName: string) => void
  closeChat: () => void
  minimizeChat: () => void
  maximizeChat: () => void
}

const ChatPopupContext = createContext<ChatPopupContextType | undefined>(undefined)

export function ChatPopupProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ChatPopupState>({
    isOpen: false,
    isMinimized: false,
    conversationId: null,
    otherUserId: null,
    otherUserName: null
  })

  const openChat = (userId: string, userName: string) => {
    setState({
      isOpen: true,
      isMinimized: false,
      conversationId: null, // Will be generated by useGetStreamConversation
      otherUserId: userId,
      otherUserName: userName
    })
  }

  const closeChat = () => {
    setState({
      isOpen: false,
      isMinimized: false,
      conversationId: null,
      otherUserId: null,
      otherUserName: null
    })
  }

  const minimizeChat = () => {
    setState(prev => ({
      ...prev,
      isMinimized: true
    }))
  }

  const maximizeChat = () => {
    setState(prev => ({
      ...prev,
      isMinimized: false
    }))
  }

  return (
    <ChatPopupContext.Provider value={{ state, openChat, closeChat, minimizeChat, maximizeChat }}>
      {children}
    </ChatPopupContext.Provider>
  )
}

export function useChatPopup() {
  const context = useContext(ChatPopupContext)
  if (context === undefined) {
    throw new Error('useChatPopup must be used within a ChatPopupProvider')
  }
  return context
}
